
import Card from '@mui/joy/Card';
import Button from '@mui/joy/Button';
import Stack from '@mui/joy/Stack';

import { getIcon } from 'utils/misc';

const RatingCardThumbs = ({setScore, score, label}: {setScore: (s: number) => void, score: number, label: React.ReactNode}) => {
    const ThumbsUpOnIcon = getIcon('ThumbUpAlt');
    const ThumbsUpOffIcon = getIcon('ThumbUpOffAlt');
    const ThumbsDownOnIcon = getIcon('ThumbDownAlt');
    const ThumbsDownOffIcon = getIcon('ThumbDownOffAlt');
    console.log('RatingCardThumbs: ', score);
    return (
        <Card >
            <Stack>
                {label}
            </Stack>

            <Stack
                direction="row"
                spacing={1}
                justifyContent="center">

                <Button
                    onClick={() => setScore(-1)}
                    color={score === -1 ? 'danger' : 'neutral'}
                    variant={score === -1 ? 'soft' : 'outlined'}
                    startDecorator={score === -1 ? <ThumbsDownOnIcon /> : <ThumbsDownOffIcon />}
                >Thumbs Down</Button>

                <Button
                    onClick={() => setScore(1)}
                    color={score === 1 ? 'success' : 'neutral'}
                    variant={score === 1 ? 'soft' : 'outlined'}
                    startDecorator={score === 1 ? <ThumbsUpOnIcon /> : <ThumbsUpOffIcon />}
                >Thumbs Up</Button>

            </Stack>
        </Card>
    );
}

export default RatingCardThumbs;
